import React, { useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { AiOutlineMenu } from 'react-icons/ai';
import Sidebar from './Sidebar';
import Terms from './modal/Terms';
import PassCard from './modal/PassCard';

export default function NavbarText({ noneMenu, backEvent, children }: any) {
  const [sidebar, setSidebar] = useState(false);
  const [terms1, setTerms1] = useState(false);
  const [terms3, setTerms3] = useState(false);
  const [passCard, setPassCard] = useState(false);
  return (
    <>
      {passCard && <PassCard setPassCard={setPassCard} />}
      {terms1 && <Terms setTerms1={setTerms1} terms1 service side />} {terms3 && <Terms setTerms3={setTerms3} terms3 side />}
      {sidebar && <Sidebar setSidebar={setSidebar} setTerms1={setTerms1} setTerms3={setTerms3} setPassCard={setPassCard} />}
      <div className='w-full h-52 md:h-[130px] flex justify-between items-center px-15 md:px-[37px] top-0 bg-back'>
        <IoIosArrowBack className='h-20 md:h-[50px] md:w-[50px] hover:cursor-pointer' onClick={backEvent} />
        <p className='text-19 md:text-40 font-preLight'>{children}</p>
        {!noneMenu ? <AiOutlineMenu onClick={() => setSidebar(true)} className='h-20 md:h-[50px] md:w-[50px] hover:cursor-pointer' /> : <p />}
      </div>
    </>
  );
}

